<script>
    export let rate;
    export let tax;
    export let optional = false;
    import {optionalTaxes, assessedValue, nonAssessedValueTaxAmounts} from './stores.js';
    import {formatMoney, unformat} from 'accounting';
    import {calculateAmount, isNotAssessedValueTax, getNonAssessedValueTaxRate, getNonAssessedValueTaxAmountName} from './calculator.js';

    let included = optional?false:true;
    $: taxAmount = included?calculateAmount(rate, $assessedValue, $nonAssessedValueTaxAmounts[tax]|0):0;

    if(isNotAssessedValueTax(rate)) {
        let nestedTaxes = $nonAssessedValueTaxAmounts;
        nestedTaxes[tax] = 0;
        nonAssessedValueTaxAmounts.set(nestedTaxes);
    }

    const setOptional = (t, r) => {
        // update optional taxes store
        let updatedTaxes = $optionalTaxes;
        updatedTaxes[t] = r;
        optionalTaxes.set(updatedTaxes);
    }

    const handleOptional = (e) => {
         included?setOptional(tax, rate):setOptional(tax, 0);
    }

    const updateNonAssessedValueStore = (e) =>{
      $nonAssessedValueTaxAmounts[tax] = unformat(e.target.value)
    }

    function countDecimalPlaces (nu) {
        console.log(`nu: ${nu}`);
        if (Math.floor(nu.valueOf()) === nu.valueOf()) return 0;

        var str = nu.toString();
        if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
            return str.split("-")[1] || 0;
        } else if (str.indexOf(".") !== -1) {
            return str.split(".")[1].length || 0;
        }
        return str.split("-")[1] || 0;
    }

    function wackyToFixed(num, minDigits=4){
        if(countDecimalPlaces(num)<minDigits)
            return num.toFixed(minDigits);
        else
            return num;
    }


</script>
<tr>
    <th scope="row">
    {#if optional}
        <label for="include-{tax}">{tax}</label>
        <input bind:checked={included} type="checkbox" id="include-{tax}" on:change="{handleOptional}">
    {:else}
        {tax}
    {/if}
    {#if isNotAssessedValueTax(rate)}
        <label for="amount-{tax}">{getNonAssessedValueTaxAmountName(rate)}</label>
        <input id="amount-{tax}" on:input="{updateNonAssessedValueStore}" placeholder="0.00">
    {/if}
    </th>
    {#if isNotAssessedValueTax(rate)}
    <td class="number-column" class:excludedtax="{!included}">{wackyToFixed(getNonAssessedValueTaxRate(rate))}</td>
    {:else}
    <td class="number-column" class:excludedtax="{!included}">{wackyToFixed(rate)}</td>
    {/if}
    <td class="number-column" class:excludedtax="{!included}">{formatMoney(taxAmount)}</td>
</tr>
<style>
    .excludedtax {
        opacity: 0.4;
    }
</style>